import { useEffect } from "react";
import action from "../../utils/qiankun/action";

const MicroMeshEditorNode = ({
  handleCardClick,
  logInfo,
  subscriptionsInfo,
  handleOpenSub,
  handleOpenPre,
  handleOpenLogin
}) => {
  // useEffect(() => {
  //   action.setGlobalState({
  //     handleCardClick: (uuid) => handleCardClick(uuid),
  //     logInfo: logInfo,
  //     subscriptionsInfo: subscriptionsInfo,
  //     handleOpenSub: (value) => handleOpenSub(value),
  //     handleOpenPre: (value) => handleOpenPre(value),
  //     handleOpenLogin: (value) => handleOpenLogin(value)
  //   });
  // }, [handleCardClick, logInfo, subscriptionsInfo, handleOpenLogin, handleOpenSub, handleOpenPre]);
  return <div id="mesheditor-root"></div>;
};

export default MicroMeshEditorNode;
